import React from "react";

export default function VideoList({
  videos,
  selectedVideoId,
  onSelect,
  onDelete,
  isAdmin,
}) {
  const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

  if (!videos.length) {
    return <div className="card">No guest speaker videos have been added yet.</div>;
  }

  function getThumbnailSrc(video) {
    if (video.thumbnailPath) {
      return `${API_URL}${video.thumbnailPath}`;
    }

    return "";
  }

  function getSourceLabel(video) {
    if (video.videoType === "youtube_live") {
      return "YouTube Live";
    }

    if (video.videoType === "youtube") {
      return "YouTube";
    }

    return "Upload";
  }

  return (
    <div className="video-list">
      {videos.map((video, index) => {
        const thumbnailSrc = getThumbnailSrc(video);

        return (
          <div
            key={video._id}
            className={`video-item ${selectedVideoId === video._id ? "active" : ""}`}
          >
            <button
              type="button"
              className="video-select"
              onClick={() => onSelect(video._id)}
            >
              {thumbnailSrc ? (
                <img
                  src={thumbnailSrc}
                  alt={video.title}
                  className="video-thumb"
                  loading="lazy"
                />
              ) : (
                <div className="video-thumb-placeholder">No Thumbnail</div>
              )}

              <div>
                <h4>
                  {index + 1}. {video.title}{" "}
                  {video.videoType === "youtube_live" && (
                    <span className="admin-badge approved">LIVE</span>
                  )}
                </h4>
                <p className="video-meta">Speaker: {video.speaker}</p>
                <p className="video-meta">
                  Date:{" "}
                  {video.date
                    ? new Date(video.date + "T00:00:00").toLocaleDateString()
                    : ""}
                </p>
                <p className="video-meta">Source: {getSourceLabel(video)}</p>
              </div>
            </button>

            {isAdmin && (
              <button
                type="button"
                className="btn delete-btn"
                onClick={() => onDelete(video._id)}
              >
                Delete
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}